/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { EomReportDto, EomReportMethod } from './eom-reports.dto';

export const EomReportMapper = entity<EomReportDto>({
  method: enumeration(EomReportMethod),
});
